export const serviceConstants = {
    SERVICE_DOMAIN: process.env.REACT_APP_SERVICE_DOMAIN ?? 'https://backend.souravdinda.com/portfolio-api',
};

export const profileConstants = {
    PROFILE_ID: process.env.REACT_APP_PROFILE_ID ?? '65fc5712ed5f13b56354a7a2',
};
